export const ClientsActionTypes = {
    API_RESPONSE_SUCCESS: '@@clients/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@clients/API_RESPONSE_ERROR',

    GET_CLIENT: '@@clients/GET_CLIENT',
    LIST_CLIENTS: '@@clients/LIST_CLIENTS',
    ADD_CLIENT: '@@clients/ADD_CLIENT',
    UPDATE_CLIENT: '@@clients/UPDATE_CLIENT',
    DELETE_CLIENT: '@@clients/DELETE_CLIENT',

    RESET: '@@clients/RESET',
};
